import { useState, useEffect, useMemo } from "react";
import { makeStyles } from "@material-ui/core";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const useStyles = makeStyles({
  particlesLayer: {
    position: "absolute",
    inset: 0,
    zIndex: 0,
    "& canvas": {
      position: "absolute !important",
      inset: 0,
    },
  },
});

let enginePromise = null;
const ensureEngine = () => {
  if (!enginePromise) {
    enginePromise = initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    });
  }
  return enginePromise;
};

export const HeroParticles = ({ id }) => {
  const classes = useStyles();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    ensureEngine().then(() => {
      if (!cancelled) setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const options = useMemo(
    () => ({
      fullScreen: { enable: false },
      background: { color: { value: "transparent" } },
      fpsLimit: 60,
      interactivity: {
        events: {
          onHover: { enable: true, mode: "grab" },
          resize: true,
        },
        modes: {
          grab: { distance: 160, links: { opacity: 0.85 } },
        },
      },
      particles: {
        color: { value: "#e0b8e0" },
        links: {
          color: "#c77dc7",
          distance: 150,
          enable: true,
          opacity: 0.6,
          width: 1.2,
        },
        move: {
          direction: "none",
          enable: true,
          outModes: { default: "out" },
          random: false,
          speed: 1,
          straight: false,
        },
        number: { density: { enable: true, area: 800 }, value: 75 },
        opacity: { value: 0.85 },
        shape: { type: "circle" },
        size: { value: { min: 1.5, max: 3.5 } },
      },
      detectRetina: true,
    }),
    []
  );

  if (!ready) return null;

  return (
    <Particles
      id={id}
      className={classes.particlesLayer}
      options={options}
    />
  );
};
